var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestigatingErrorIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 765,
    height: 268,
    viewBox: "0 0 765 268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#1f1f53;}.c{fill:#2d2d72;}.d{fill:#181850;}.e{fill:#1d1d5f;}.f,.o{fill:#8bbfe6;}.g{fill:#feb3ae;}.h{fill:#dd8e8e;}.i{fill:#ed9f9d;}.j{fill:#161643;}.k{fill:#09092b;}.l{fill:#150d03;}.m{fill:#0d0d34;}.n{fill:#b4dfff;}.o{stroke:rgba(0,0,0,0);}.p{fill:#0e0e45;opacity:0.7;}.q,.s{fill:#fff;}.r{fill:#ff2467;}.s{opacity:0.172;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.979,
    y1: 2.061,
    x2: 0.306,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292965"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-258 -67)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 765,
    height: 268,
    transform: "translate(258 67)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504.027 32.519)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-.027,387.982v-26.81c12.383-19.221,83-49.592,157.9-5.282,46.526,27.526,89.518-14.981,179.995-24.328s110.021,21.106,177.227,19.948-10.736-64.8,139.081-66.833c69.34-.943,109.6,12.193,109.6,12.193V401.557H-.027Z",
    transform: "translate(-245.202 -99.851)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.786 72.943)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.065,261.142h-48.9s-39.713,15.956-39.713,63.293v66.428H259.778V324.435C259.778,277.1,220.065,261.142,220.065,261.142Z",
    transform: "translate(-126.8 -162.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M179.893,283.824s-6.426,1.761-9.077,4.512a36.216,36.216,0,0,0-5.314,8.182l46.2,21.146Z",
    transform: "translate(-142.343 -172.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M193.929,193.19s-20.7,7.348-66.563,24.633c0,0,20.146,2.077,35.239,28.037H194.88Z",
    transform: "translate(-124.936 -131.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M244.93,193.19s23.142,7.336,68.827,24.633c0,0-22.408,2.077-37.5,28.037H243.98Z",
    transform: "translate(-178.166 -131.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M171.148,411.008l3.032,47.863-6.955.054,2.639-47.9Z",
    transform: "translate(-143.13 -230.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M324.4,411.026l.231,47.889-7.3-.027,5.79-47.871Z",
    transform: "translate(-211.647 -230.486)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M244.71,441.025l-1.294-67.462L245.223,371l1.294,69.993Z",
    transform: "translate(-177.908 -212.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 24.906,
    height: 3.542,
    transform: "translate(30.466 164.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M203.093,283.824l28.5,34.872,20.843-34.872Z",
    transform: "translate(-159.502 -172.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M245.891,230.892H228.409c-3.531,0-6.394,3.214-6.394,7.178V255.7c0,9.384,6.776,15.123,15.135,15.123s15.135-5.739,15.135-15.123V238.07C252.286,234.106,249.423,230.892,245.891,230.892Z",
    transform: "translate(-168.139 -148.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M220.047,256.676s1.226,11.341,15.136,11.341,15.136-11.341,15.136-11.341Z",
    transform: "translate(-167.241 -160.036)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.365)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 10.477,
    cy: 10.477,
    r: 10.477,
    transform: "matrix(0.159, -0.987, 0.987, 0.159, 20.736, 69.743)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 10.477,
    cy: 10.477,
    r: 10.477,
    transform: "matrix(0.159, -0.987, 0.987, 0.159, 92.138, 69.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,0H8.189a0,0,0,0,1,0,0V16.051a0,0,0,0,1,0,0h0A8.189,8.189,0,0,1,0,7.862V0A0,0,0,0,1,0,0Z",
    transform: "translate(24.56 45.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M8.189,0h0a0,0,0,0,1,0,0V16.051a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V8.189A8.189,8.189,0,0,1,8.189,0Z",
    transform: "translate(112.339 61.137) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M216.605,190.01l-.063.061c.982.08,1.972.132,2.975.132h0a36.058,36.058,0,0,0,8.737-1.071c.013-.024.023-.049.035-.074a35.453,35.453,0,0,0,26.93-34.3V113.307c0-19.539-15.984-16.426-35.7-16.426h0c-19.717,0-35.7-3.113-35.7,16.426v41.452A35.5,35.5,0,0,0,216.605,190.01Z",
    transform: "translate(-151.069 -87.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M248.86,229.623H239.6a1.778,1.778,0,0,1-1.778-1.778h0a1.779,1.779,0,0,1,1.778-1.778h9.257a1.779,1.779,0,0,1,1.778,1.778h0A1.778,1.778,0,0,1,248.86,229.623Z",
    transform: "translate(-175.721 -146.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M241.184,204.2a39.945,39.945,0,0,0-10.572.3,39.944,39.944,0,0,0-10.572-.3,11.862,11.862,0,0,0-10.726,11.836h0a2.165,2.165,0,0,0,2.5,2.142,117.554,117.554,0,0,1,18.03-1.319v0l.767,0,.767,0v0a117.554,117.554,0,0,1,18.03,1.319,2.165,2.165,0,0,0,2.5-2.142h0A11.862,11.862,0,0,0,241.184,204.2Z",
    transform: "translate(-162.707 -135.989)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.371 50.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M241.1,203.234a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,241.1,203.234Z",
    transform: "translate(-211.308 -185.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M255.489,203.234a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,255.489,203.234Z",
    transform: "translate(-217.876 -185.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M245.548,202.322h-1.634a3.212,3.212,0,0,1-3.188-3.611l.817-7.835a3.212,3.212,0,0,1,3.187-2.814h0a3.212,3.212,0,0,1,3.188,2.814l.817,7.835A3.212,3.212,0,0,1,245.548,202.322Z",
    transform: "translate(-213.405 -179.426)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M7.192,0h11.36a8.06,8.06,0,0,1,8.06,8.06v.933A11.722,11.722,0,0,1,14.89,20.716H13.524A13.524,13.524,0,0,1,0,7.192v0A7.192,7.192,0,0,1,7.192,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M13.523,0H14.89A11.722,11.722,0,0,1,26.612,11.722v.933a8.06,8.06,0,0,1-8.06,8.06H7.192A7.192,7.192,0,0,1,0,13.523v0A13.523,13.523,0,0,1,13.523,0Z",
    transform: "translate(58.746 20.716) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 6.741,
    height: 4.876,
    transform: "translate(25.879 5.653)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 11.659,
    height: 5.239,
    rx: 2.265,
    transform: "translate(0 0.012)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 11.659,
    height: 5.239,
    rx: 2.265,
    transform: "translate(50.808 0)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 67.695,
    cy: 13.513,
    rx: 67.695,
    ry: 13.513,
    transform: "translate(0 31.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173,118.108l6.451-29.587a12.254,12.254,0,0,1,11.972-9.643h45.887a12.254,12.254,0,0,1,11.934,9.472l6.936,29.759Z",
    transform: "translate(-146.132 -78.877)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M184.453,261.142l-31.821,14.15c21.914,10.808,58.186,37.4,58.186,37.4Z",
    transform: "translate(-136.469 -162.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M206.9,78.877s12.145,12.142,38.487,0Z",
    transform: "translate(-161.239 -78.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M284.077,287.4l12.17,9.8s-33.556,11.046-49.208,39.67C247.039,336.871,258.628,294.913,284.077,287.4Z",
    transform: "translate(-179.562 -174.061)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.316 2.175)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M199.93,135.653c14.146,2.523,37.861,4.264,66.748-3.293l-2.822-12.1s-25.44,6.272-65.446,1.384l1.52,14.012Z",
    transform: "translate(-185.681 -99.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M187.72,104.579l-2.354-21.7c-1.964.316-4.73,5.33-5.006,7.468l-5.371,24.672,2.59-11.878Q182.792,103.983,187.72,104.579Z",
    transform: "translate(-174.99 -82.879)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M189.24,135.608,187.72,121.6q-4.927-.6-10.14-1.438l-2.59,11.878q1.059.368,2.063.688a102.384,102.384,0,0,0,12.187,2.885Z",
    transform: "translate(-146.674 -97.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M165.46,145.583s-19.93,7.325-9.452,18.9c0,0-37.167-4.332-32.749-12.947,3.469-6.763,27.951-9.526,27.951-9.526",
    transform: "translate(-122.895 -107.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M183.009,372.258l7.86-10.085,9.52,10.085Z",
    transform: "translate(-150.335 -208.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M201.857,375.39l5.081-6.355,5.164,6.355Z",
    transform: "translate(-158.938 -211.323)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.508 153.986)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M5.295,11.934h0A8.235,8.235,0,0,1,0,4.238V.876L.867.625a15.9,15.9,0,0,1,8.854,0l.047.014-1.338,1a12.25,12.25,0,0,0-6.547.076l-.668.194V4.5A6.345,6.345,0,0,0,5.3,10.431,6.343,6.343,0,0,0,9.351,5.042L10.589,3.6v.637a8.235,8.235,0,0,1-5.3,7.7Z",
    transform: "translate(0 1.289)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M109.591,374.327l3.3,5.271,8.384-9.747h0l-8.386,6.28Z",
    transform: "translate(-109.591 -369.85)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.533 80.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M298.525,258.9l-19.443-8.632,10.495-24.2a44.27,44.27,0,0,0-21.3,11.794c-19.614,15.558-23.884,53.847-24.812,69.23l.083,5.75C258.391,277.595,298.525,258.9,298.525,258.9Z",
    transform: "translate(-243.463 -226.066)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.401 65.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(14.979 13.767)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.599 211.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(14.979 13.767)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(216.032 159.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(379.032 79.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(-55.968 89.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(-143.968 135.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(-160.968 149.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(-173.968 164.884)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.514 165.856)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(13.948 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(0 14.236)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(449.514 150.856)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(13.948 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 25.722,
    height: 10.07,
    transform: "translate(0 14.236)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M97.186,438.664s136.6,5.8,197.938-25.172c23.874-12.055,72.816-32.385,150.939-6.31s37.787-24.258,101.733-24.5c45.236-.172,31.556,7.625,76.215,6.787S667.9,374.9,725.245,367.917c89.822-10.933,132.231,27.4,132.231,27.4v43.362H289.915Z",
    transform: "translate(-338.9 -136.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M131.928,156.35l-24.3,11.967-.809-2.772,24.318-10.881a1.387,1.387,0,0,1,.791.642A2.007,2.007,0,0,1,131.928,156.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "r",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(105.484 165.965) rotate(-22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M95.08,168.747a52.548,52.548,0,0,1-23.766,0c-7.845-1.935,1.033-5.555-5.3-7.741S53.412,162.9,46,160s.373-8.239-6.553-11.022-11.127-.047-15.453-2.868-8.631-6.313-1.852-8.417,21.581-2.1,28.969,0,.584,8.417.584,8.417,8.763-2.063,15.424.721.643,6.951,8.213,10.741,13.995,2.655,19.326,5.448S101.6,167.059,95.08,168.747Z",
    transform: "translate(8 1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestigatingErrorIllustration);
export default __webpack_public_path__ + "static/media/investigating-error-illustration.e99961186a4dbdad7399f0219f66fcfc.svg";
export { ForwardRef as ReactComponent };